import { Table } from 'antd';
import styled from 'styled-components';

export const CommunityIncentivesStyledTable = styled(Table)`
  &&&&&& {
    width: 100%;

    tr {
      font-family: var(--font-regular);
      font-weight: 200;
      color: var(--text-primary);
      background-color: #fff;

      &.mixed-selection {
        .ant-table-selection-column {
          visibility: hidden;
        }

        &.selectable {
          .ant-table-selection-column {
            visibility: visible;
          }
        }
      }

      td {
        padding: 6px 0px;
        vertical-align: top;

        &.ant-table-cell {
          background: white;
        }

        &.ant-table-cell-row-hover {
          .hover-visible {
            visibility: visible;
          }
        }
      }

      th {
        font-family: var(--font-bold);
        text-transform: uppercase;
        padding-left: 0;
        background-color: #fff;

        &.ant-table-cell::before {
          background-color: transparent;
        }
      }
    }

    .ant-table-thead {
      .padded-column-header {
        padding-left: 44px;
      }
    }

    .ant-table-body {
      overflow-y: auto !important;
      padding-inline-end: 15px;
      scrollbar-width: thin;
      scrollbar-color: #89919d transparent;
    }

    .manage-incentives-modal & .ant-table {
      min-height: 47vh;
    }

    .ant-tabs-content & .ant-table-body {
      max-height: fit-content !important;
    }
  }
`;

export default CommunityIncentivesStyledTable;
